import { Component } from 'react';
import PropTypes from 'prop-types';
import differenceInMinutes from 'date-fns/difference_in_minutes';
import Icon from '../../../../directives/Icon/Icon';
import stopwatch from '../../../../decorators/stopwatch';
import responsive from '../../../../decorators/responsive';
import { getDayHourMinute, getDatetimeActionType } from './helper';
/**
 * Метод получения заголовка компоненты
 * @param datetimeAction - целевое действие
 * @param xs - флаг мобильного отображения
 * @param text - приставка
 */
const getTitle = ({
  datetimeAction,
  xs,
  text
}) => {
  const {
    days,
    hours,
    minutes
  } = getDayHourMinute(datetimeAction);
  switch (getDatetimeActionType(datetimeAction)) {
    case 'today':
      {
        const renderH = hours ? `${hours} ${I18n.t('pages.account.timer.hours', {
          count: hours
        })}` : '';
        const renderM = minutes ? `${minutes} ${I18n.t('pages.account.timer.minutes', {
          count: minutes
        })}` : '';
        const datetimeText = `${renderH} ${renderM}`;
        return xs ? datetimeText : `${text} ${I18n.t('components.OrderTimer.across')} ${datetimeText}`;
      }
    case 'tomorrow':
      return `${text} ${I18n.t('components.OrderTimer.tomorrow')}`;
    case 'dayAfterTomorrow':
      return `${text} ${I18n.t('components.OrderTimer.day_after_tomorrow')}`;
    default:
      {
        const renderD = days ? `${days} ${I18n.t('pages.account.timer.day', {
          count: days
        })}` : '';
        return xs ? renderD : `${text} ${I18n.t('components.OrderTimer.across')} ${renderD}`;
      }
  }
};
class OrderTimer extends Component {
  static propTypes = {
    text: PropTypes.string,
    minutesPassed: PropTypes.number,
    xs: PropTypes.bool,
    datetimeAction: PropTypes.instanceOf(Date)
  };
  shouldComponentUpdate(nextProps) {
    return nextProps.minutesPassed !== this.props.minutesPassed || nextProps.xs !== this.props.xs;
  }
  render() {
    const {
      text,
      datetimeAction,
      xs
    } = this.props;
    if (differenceInMinutes(datetimeAction, new Date()) <= 0) {
      return null;
    }
    const title = getTitle({
      datetimeAction,
      xs,
      text
    });
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "status__item"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
      name: "combined-shape"
    })), /*#__PURE__*/React.createElement("div", null, title)));
  }
}
export default stopwatch(responsive(OrderTimer, ['xs']));